import { render, staticRenderFns } from "./DropdownItems.vue?vue&type=template&id=d9b6008a&"
import script from "./DropdownItems.vue?vue&type=script&lang=ts&"
export * from "./DropdownItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports